import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { SearchX } from "lucide-react";
export default function NotFoundPage() {
	return (
		<div className="flex min-h-[80vh] items-center justify-center px-6">
			<Card className="max-w-lg w-full text-center shadow-lg">
				<CardContent className="pt-10 pb-10 flex flex-col items-center gap-6">
					<SearchX className="h-14 w-14 text-muted-foreground" />

					<h1 className="text-5xl font-bold tracking-tight">404</h1>

					<h2 className="text-xl font-semibold">Page not found</h2>

					<p className="text-muted-foreground max-w-md">
						The page you are looking for doesn't exist or may have been moved.
					</p>

					<div className="flex gap-3">
						<Button asChild>
							<Link to="/">Go to formatter</Link>
						</Button>

						<Button variant="outline" asChild>
							<Link to="/examples">View examples</Link>
						</Button>
					</div>
				</CardContent>
			</Card>
		</div>
	);
}
